import { Address } from '@root/types';

export default function formatCityLocalityRegion({
  city,
  postalCode,
  countryCode,
  abbreviatedRegion,
}: Address): string {
  const isUk = countryCode?.toLowerCase() === 'gb';

  return isUk ? `${city} ${postalCode}` : `${city}, ${abbreviatedRegion} ${postalCode}`;
}
